<script>
import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  name: 'NestedCustomViewNode',
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    expanded: {
      type: Object,
      required: true,
    },
    node: {
      type: Object,
      required: true,
    },
    searching: {
      type: Boolean,
      default: false,
    },
    routeMode: {
      type: String,
      default: 'conversation',
    },
  },
  computed: {
    isFolder() {
      return this.node.type === 'folder';
    },
    isOpen() {
      return this.searching || this.expanded[this.node.id] === true;
    },
    toState() {
      if (this.node.type === 'label') {
        return this.routeMode === 'contact'
          ? frontendURL(
              `accounts/${this.accountId}/labels/${this.node.labelTitle}/contacts`
            )
          : frontendURL(
              `accounts/${this.accountId}/label/${this.node.labelTitle}`
            );
      }
      return frontendURL(
        `accounts/${this.accountId}/custom_view/${this.node.viewId}`
      );
    },
  },
};
</script>

<template>
  <li>
    <button
      v-if="isFolder"
      type="button"
      class="flex items-center w-full h-7 px-2 my-1 text-sm font-medium text-left rounded-md text-slate-700 hover:bg-slate-25 dark:text-slate-100 dark:hover:bg-slate-800"
      :aria-expanded="isOpen.toString()"
      @click="$emit('toggle', node.id)"
    >
      <span class="w-4 mr-1 text-xs" aria-hidden="true">
        {{ isOpen ? '▾' : '▸' }}
      </span>
      <span class="overflow-hidden whitespace-nowrap text-ellipsis">
        {{ node.label }}
      </span>
    </button>

    <router-link
      v-else
      v-slot="{ href, isActive, navigate }"
      :to="toState"
      custom
    >
      <div
        class="flex items-center h-7 px-2 my-1 text-sm font-medium rounded-md hover:bg-slate-25 dark:hover:bg-slate-800"
        :class="{
          'bg-woot-25 dark:bg-slate-800': isActive,
          'text-woot-500': isActive,
          'text-slate-700 dark:text-slate-100': !isActive,
        }"
      >
        <span class="w-4 mr-1 text-xs text-center" aria-hidden="true">•</span>
        <span
          v-if="node.color"
          class="w-3 h-3 mr-1 rounded-sm"
          :style="{ backgroundColor: node.color }"
          aria-hidden="true"
        />
        <a
          :href="href"
          class="overflow-hidden whitespace-nowrap text-ellipsis"
          :title="node.label"
          @click="navigate"
        >
          {{ node.label }}
        </a>
      </div>
    </router-link>

    <ul
      v-if="isFolder && isOpen"
      class="pl-3 ml-2 mb-0 list-none border-l border-slate-100 dark:border-slate-800"
    >
      <NestedCustomViewNode
        v-for="child in node.children"
        :key="child.id"
        :account-id="accountId"
        :expanded="expanded"
        :node="child"
        :route-mode="routeMode"
        :searching="searching"
        @toggle="$emit('toggle', $event)"
      />
    </ul>
  </li>
</template>
